// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1510":"b6249c79","2588":"3cd1801d"}[chunkId] + ".chunk.css");